<template>
  <div class="bottom flex">
    <div>
      <p>版权所有：江苏畅想之星信息技术有限公司 <span>苏公网安备32031102020210号</span></p>
      <p>
        地址：中国矿业大学徐州科技创业园B座 <span>邮编：bjcxstar@163.net</span
        ><span>客服电话：400-660-4011</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scope>
.bottom {
  background: #cccccc;
  text-align: center;
  color: #666666;
  font-size: 12px;
  height: 80px;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 9999;
  p {
    line-height: 25px;
    span {
      margin-left: 15px;
    }
  }
}
</style>
